import { Warning } from '@mui/icons-material'
import { Box, CircularProgress, styled, Typography } from '@mui/material'
import { Link } from 'react-router-dom'
import { DataPanel } from '../../../components/DataPanel'

// TODO: better typed theme
const WarningIcon = styled(Warning)(({ theme }: any) => ({ color: theme.warning }))

interface ResultsStepProps {
    formErrors: { location: string; message: string }[]
    pending: boolean
    claimNumber?: string
}

const ResultsStep = (props: ResultsStepProps) => {
    if (props.pending) {
        return (
            <Box
                sx={{
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    marginTop: 8,
                }}
            >
                <CircularProgress size="150px" />
            </Box>
        )
    }

    const renderSuccess = () => (
        <Box sx={{ display: 'flex', flexDirection: 'column', textAlign: 'center' }}>
            <Typography sx={{ fontWeight: 'bold', fontSize: 40 }}>
                You have completed the Dental Claim Form
            </Typography>
            <Typography>
                Claim has been submitted.{' '}
                <Link to={`/claims/${props.claimNumber}/summary`}>Click here</Link> to see the
                status of the claim
            </Typography>
        </Box>
    )

    const renderFailure = () => (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                textAlign: 'center',
                width: '100%',
            }}
        >
            <WarningIcon
                sx={{ marginLeft: 'auto', marginRight: 'auto', width: '100px', height: '100px' }}
            />
            <Typography sx={{ fontWeight: 'bold', fontSize: 40 }}>
                Claim has not been submitted
            </Typography>
            <Typography sx={{ marginBottom: 2 }}>Please correct errors</Typography>

            {props.formErrors.map(({ location, message }, i) => (
                <Box
                    key={i}
                    sx={{
                        display: 'flex',
                        width: '70%',
                        minHeight: '40px',
                        alignItems: 'center',
                        alignContent: 'baseline',
                        borderRadius: 1,
                        borderColor: 'black',
                        borderWidth: 1,
                        backgroundColor: 'white',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        marginBottom: 2,
                        padding: 2,
                    }}
                >
                    <WarningIcon sx={{ marginRight: 1 }} />
                    <Typography sx={{ marginRight: 4 }}>{message}</Typography>
                    <Typography sx={{ marginRight: 0, marginLeft: 'auto' }}>{location}</Typography>
                </Box>
            ))}
        </Box>
    )

    return (
        <DataPanel
            title="Results"
            content={props.formErrors.length ? renderFailure() : renderSuccess()}
        />
    )
}

export default ResultsStep
